@if (data) {
<div class="preview-exit-screen" [class.mobile-view]="viewMode === 'mobile'"
  [style.background-color]="viewMode === 'mobile' ? '#e5e5e5' : data.backgroundColor" [style.display]="'flex'"
  [style.flex-direction]="viewMode === 'mobile' ? 'row' : 'column'"
  [style.height]="viewMode === 'mobile' ? '100%' : 'auto'"
  [style.justify-content]="viewMode === 'mobile' ? '' : data.verticalAlignment"
  [style.align-items]="viewMode === 'mobile' ? '' : data.horizontalAlignment">
  <div class="preview-exit-screen-content" [class.mobile-view]="viewMode === 'mobile'" [style.display]="'flex'"
    [style.flex-direction]="'column'" [style.align-items]="viewMode === 'mobile' ? 'center' : data.horizontalAlignment"
    [style.text-align]="viewMode === 'mobile' ? 'center' : data.textAlign"
    [style.background-color]="viewMode === 'mobile' ? data.backgroundColor : 'transparent'"
    [style.height]="viewMode === 'mobile' ? '100%' : 'auto'">
    @if (data.imageUrl && data.imagePosition === 'top') {
    <div [style.display]="'flex'" [style.justify-content]="data.imageHorizontalAlignment" [style.width]="'100%'">
      <img [src]="data.imageUrl" alt="Exit Screen Logo" [style.width]="data.imageSizePx + 'px'" [style.height]="'auto'"
        [style.object-fit]="'contain'" />
    </div>
    }
    <h3 class="m-0 p-0" [style.color]="data.titleColor" [style.font-size]="data.titleFontSize"
      [class.mobile-view]="viewMode === 'mobile'" [style.font-family]="data.titleFontFamily"
      [style.font-weight]="data.titleFontWeight">
      {{ data.title }}
    </h3>
    <p class="m-0 p-0" [style.color]="data.descriptionColor" [style.font-size]="data.descriptionFontSize"
      [class.mobile-view]="viewMode === 'mobile'" [style.font-family]="data.descriptionFontFamily"
      [style.font-weight]="data.descriptionFontWeight">
      {{ data.description }}
    </p>

    @if (redirectionOption) {
    <div class="preview-exit-screen-content-redirection" [class.mobile-view]="viewMode === 'mobile'">
      @if (reviewProvider) {
      <img class="preview-exit-screen-content-redirection__logo" [class.mobile-view]="viewMode === 'mobile'"
        src="assets/images/logo/google.svg" alt="Google logo" />
      }
      @if (msgToDisplay) {
      <p class="preview-exit-screen-content-redirection__message mt-4" [class.mobile-view]="viewMode === 'mobile'">{{
        msgToDisplay }}</p>
      }
      @if (url) {
      <a class="preview-exit-screen-content-redirection__btn" [class.mobile-view]="viewMode === 'mobile'" [href]="url"
        target="_blank" rel="noopener noreferrer">
        <i class="bi bi-box-arrow-up-right"></i>

        Open Google
      </a>
      }
    </div>
    }

    @if (!data.icxBrand) {
    <div class="preview-exit-screen-content-icx-brand" [class.mobile-view]="viewMode === 'mobile'">
      <p class="m-0 p-0" [class.mobile-view]="viewMode === 'mobile'">Powered by </p>
      <img [class.mobile-view]="viewMode === 'mobile'" src="assets/images/logo/ICXBEE.svg"
        alt="ICXBee logo" />
    </div>
    }
    @if (data.imageUrl && data.imagePosition === 'bottom') {
    <div [class.mobile-view]="viewMode === 'mobile'" [style.display]="'flex'"
      [style.justify-content]="data.imageHorizontalAlignment" [style.width]="'100%'" [style.margin-top]="'16px'">
      <img [src]="data.imageUrl" alt="Exit Screen Logo" [style.width]="data.imageSizePx + 'px'" [style.height]="'auto'"
        [style.object-fit]="'contain'" />
    </div>
    }
  </div>
</div>
}